/* HERE & ALWAYS — Editorial JS (global)
   - ENTER: one-shot CTA underline wipe (cover-grow → cover-full)
   - EXIT: sweep (cover-shrink), direction is controlled in CSS
   - Touch devices: NOW SUPPORTED (tap animates)
   - Keyboard focus behaves like ENTER / BLUR like EXIT
   - Section rails can suspend via a parent .is-scrolling class

   NOTE:
   - To flip exit direction on a specific CTA, add class .ha-cta--exit-rtl
   - To let a section "proxy" hover from a parent tile without double-firing,
     add attribute data-ha-proxied to that CTA. We will skip mouseenter/leave
     on that CTA but still handle focus/blur for accessibility.
*/
(function () {
  if (window.__haEditorialInit) return;
  window.__haEditorialInit = true;

  function msFromCssTime(cssTime) {
    if (!cssTime) return 400;
    cssTime = String(cssTime).trim();
    if (cssTime.endsWith('ms')) return parseFloat(cssTime);
    if (cssTime.endsWith('s'))  return parseFloat(cssTime) * 1000;
    var v = parseFloat(cssTime);
    return isNaN(v) ? 400 : v;
  }

  function isRailScrolling(node) {
    var el = node;
    while (el && el !== document.documentElement) {
      if (el.classList && el.classList.contains('is-scrolling')) return true;
      el = el.parentNode;
    }
    return false;
  }

  function enter(link){
    if (isRailScrolling(link)) return;
    link.classList.remove('cover-full','cover-grow','cover-shrink');
    link.classList.add('cover-grow');

    var styles = getComputedStyle(link);
    var dur = msFromCssTime(styles.getPropertyValue('--ha-sweep-time') || '.4s');

    clearTimeout(link.__haTimer);
    link.__haTimer = setTimeout(function(){
      link.classList.remove('cover-grow');
      link.classList.add('cover-full');
    }, dur);
  }

  function leave(link){
    clearTimeout(link.__haTimer);
    link.classList.remove('cover-grow','cover-full');
    var styles = getComputedStyle(link);
    var dur = msFromCssTime(styles.getPropertyValue('--ha-sweep-time') || '.4s');

    link.classList.add('cover-shrink');
    clearTimeout(link.__haExitTimer);
    link.__haExitTimer = setTimeout(function(){
      link.classList.remove('cover-shrink');
    }, dur);
  }

  function onEnter(e){ enter(e.currentTarget); }
  function onLeave(e){ leave(e.currentTarget); }

  function bindCtas(root) {
    var ctas = (root || document).querySelectorAll('.ha-cta');
    for (var i = 0; i < ctas.length; i++) {
      var el = ctas[i];
      if (el.__haBound) continue;
      el.__haBound = true;

      var isProxied = el.hasAttribute('data-ha-proxied');

      /* Desktop hover */
      if (!isProxied) {
        el.addEventListener('mouseenter', onEnter);
        el.addEventListener('mouseleave', onLeave);
      }

      /* Keyboard accessibility */
      el.addEventListener('focus', onEnter);
      el.addEventListener('blur', onLeave);

      /* Touch support (passive to avoid scroll blocking) */
      el.addEventListener('touchstart', function(ev){
        // don't block scroll; just kick the animation
        // If user is scrolling, CSS :active already provides feedback
        enter(ev.currentTarget);
      }, { passive: true });

      el.addEventListener('touchend', function(ev){
        leave(ev.currentTarget);
      }, { passive: true });

      el.addEventListener('touchcancel', function(ev){
        leave(ev.currentTarget);
      }, { passive: true });
    }
  }

  /* Initial bind */
  bindCtas(document);

  /* Observe future nodes (sections, AJAX, etc.) */
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('.ha-cta')) bindCtas(node.parentNode || node);
        else bindCtas(node);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();